<template>
  <v-container fluid fill-height text-center style="background-color:black">
    <v-layout align-center justify-center>
      <v-flex>
        <h1 class="display-1 font-weight-medium white--text">Usuário sem permissões neste sistema.</h1>
        <h1 class="headline font-weight-medium white--text">Usuário será deslogado automaticamente após alguns segundos.</h1>
        <h1 class="title font-weight-regular white--text">Verifique com o seu administrador qual sistema você deve acessar.</h1>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    dialog: true
  }),
  mounted() {
    this.logOut()
  },
  methods: {
    logOut() {
      setTimeout(() => {
        this.$store.dispatch("logOut");
      }, 9000);
    },
  }
};
</script>
